var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Menu } from '@headlessui/react';
import { store, useAppDispatch, useAppSelector } from '../../../../../store';
import { participantsSelector } from '../../../../../store/slices/participantSlice';
import sendAPIRequest from '../../../../../helpers/api/plugNmeetAPI';
import { updateIsActiveRaisehand } from '../../../../../store/slices/bottomIconsActivitySlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { CommonResponse, DataMessageReq, } from '../../../../../helpers/proto/plugnmeet_common_api_pb';
import { DataMsgBodyType } from '../../../../../helpers/proto/plugnmeet_datamessage_pb';
const LowerHandMenuItem = ({ userId }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const onClick = async () => {
        const session = store.getState().session;
        const body = new DataMessageReq({
            roomSid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            msgBodyType: DataMsgBodyType.OTHER_USER_LOWER_HAND,
            msg: participant === null || participant === void 0 ? void 0 : participant.userId,
        });
        const r = await sendAPIRequest('dataMessage', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            dispatch(updateIsActiveRaisehand(false));
        }
        else {
            toast(t(res.msg), {
                type: 'error',
            });
        }
    };
    const render = () => {
        return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("button", { className: "text-gray-900 dark:text-darkText group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs lg:text-sm transition ease-in hover:bg-primaryColor hover:text-white", onClick: () => onClick(), children: t('footer.icons.lower-hand') })) }) }));
    };
    return _jsx(_Fragment, { children: (participant === null || participant === void 0 ? void 0 : participant.metadata.raised_hand) ? render() : null });
};
_react_refresh_temp_1 = LowerHandMenuItem;
$RefreshReg$(_react_refresh_temp_1, "LowerHandMenuItem");
_react_refresh_temp_2(LowerHandMenuItem, "qNu93Q9LL0Qd5Edd2kw1qa4ZBlg=", false, () => [useAppSelector, useAppDispatch, useTranslation]);
export default LowerHandMenuItem;
